import React from "react";
import Head from "./Fields/Head";
import Items from "./Fields/Items";
import createForm from "../Form";

class SzamlazzForm extends React.Component {
    render() {
        const disabled = !!this.props.values[this.props.componentConfig.idfield];

        return (
            <form onSubmit={this.props.handleSubmit}>
                <Head {...this.props} disabled={disabled}/>
                {!this.props.invoiceTypes.EDITABLE(this.props.values.type) && <Items {...this.props} />}
            </form>
        );
    }
}

export default createForm(SzamlazzForm);